import React from "react";
import StepsComponent from "../../../../components/StepsComponent/StepsComponent";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./ProcessBuilder.module.css";
import ProcessSetup from "../ProcessSetup/ProcessSetup";
import InstructionSetup from "../InstructionSetup/InstructionSetup";
import CreateHACCPCompliance from "./CreateHACCPCompliance/CreateHACCPCompliance";

const ProcessBuilder = () => {
  const steps = ["Process Setup", "HACCP Compliance", "Instruction Setup"];
  const navigate = useNavigate();

  const { search } = useLocation();

  const current = Number(new URLSearchParams(search).get("step")) || 0;
  const onNext = () => {
    if (current < steps.length - 1) {
      navigate(`?step=${current + 1}`);
    }
  };

  const onPrev = () => {
    if (current > 0) {
      navigate(`?step=${current - 1}`);
    }
  };
  return (
    <div>
      <div className={styles.stepContainer}>
        <StepsComponent
          backIcon={true}
          steps={steps}
          currentStepIndex={current}
          onPrev={onPrev}
          onNext={onNext}
        />
      </div>
      <div className={styles.compMainCont}>
        {current == 0 ? (
          <ProcessSetup />
        ) : current == 1 ? (
          <CreateHACCPCompliance />
        )
        : current == 2 ? (
          <InstructionSetup />
        )
         : null}
      </div>
    </div>
  );
};

export default ProcessBuilder;
